// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"167":"detail","171":"error404","177":"home"}[chunkId] + "-legacy." + {"167":"60de6e6b","171":"74d209cc","177":"4baea7c8"}[chunkId] + ".js";
};